import { render } from "./AppServices.vue?vue&type=template&id=6ef8a77b"
import script from "./AppServices.vue?vue&type=script&lang=js"
export * from "./AppServices.vue?vue&type=script&lang=js"

import "./AppServices.vue?vue&type=style&index=0&id=6ef8a77b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__